
import { UserManagementService } from "../core/user-management-service";

export class ProdUserManagementService extends UserManagementService
{
    constructor(session){
        super(session);
    }
    
    getUserManagementUrl = ()=> `https://prod.best-experiences.com/withlogin-universal-redemptions/api/user-management`;
    
    getUserMenuUrl = ()=> `https://prod.best-experiences.com/withlogin-universal-redemptions/api/user-info/user-menu`;
    getUserInfoUrl = ()=> `https://prod.best-experiences.com/withlogin-universal-redemptions/api/user-info`;

} 
